import { render, staticRenderFns } from "./user_menu_explore_premium.vue.js?vue&type=template&id=2bbd5b16&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_explore_premium.vue?vue&type=template&id=2bbd5b16&vue3"
import script from "./user_menu_explore_premium.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_explore_premium.vue?vue&type=script&lang=js&vue3"
export * from "./user_menu_explore_premium.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_explore_premium.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports